module.exports = __webpack_public_path__ + "media/fitnessmania-intro.cd78794f.mp4";